/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines the default path for resolving an external theme.json document.
 *
 * ```typescript
 *   import {CUSTOM_THEME_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CUSTOM_THEME_PATH = 'theme.json';

/**
 * Defines the default path for resolving an external theme logo image.
 *
 * ```typescript
 *   import {CUSTOM_LOGO_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CUSTOM_LOGO_PATH = 'assets/img/logo.png';

/**
 * Defines the default path for resolving an external theme logo image
 * optimized for display in the application header.
 *
 * The header logo is an optional, smaller-framed variant of `logo.png`. A
 * reseller may provide it when the standard logo renders too large in the
 * fixed-height header; resellers that omit it fall back to `CUSTOM_LOGO_PATH`.
 *
 * ```typescript
 *   import {CUSTOM_HEADER_LOGO_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CUSTOM_HEADER_LOGO_PATH = 'assets/img/logo-header.png';

/**
 * Defines the default path for resolving an external theme background
 * image.
 *
 * ```typescript
 *   import {BACKGROUND_IMG_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const BACKGROUND_IMG_PATH = 'assets/img/bg.jpg';

/**
 * Defines the default path for resolving the current theme login background
 * image. Unlike `BACKGROUND_IMG_PATH`, this image is not reseller overridable.
 *
 * ```typescript
 *   import {CURRENT_BACKGROUND_IMG_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CURRENT_BACKGROUND_IMG_PATH = 'assets/img/bg-current.jpg';
